//@flow
///* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

// const getType = require('../../style-spec/util/get_type');
import window from '../../util/window';
import * as util from '../../util/util';
import {getArrayBuffer} from '../../util/ajax';
import {Evented} from '../../util/evented';
import loadTileJSON from '../../source/load_tilejson';
import Lerc from "lerc";
import lercUtil from './util';
import Texture from '../../render/texture'

class LercTileSource extends Evented {
    constructor(id, options, dispatcher, eventedParent) {
        super();
        this.id = id;
        this.dispatcher = dispatcher;

        this.minzoom = 0;
        this.maxzoom = 22;
        this.roundZoom = true;
        this.scheme = 'xyz';
        this.tileSize = options.tileSize || 512;
        this._loaded = false;
        this.mask = options.mask;
        this.maskUrl = options.maskUrl;
        this.min = options.minValue;
        this.max = options.maxValue;
        this.headers = options.headers || [];
        this.colors = options.colors;
        this.paint = lercUtil.handlePaint(options.paint);

        this.lercVersion = options.lercVersion || 2;
        this.step = (this.max - this.min) / 10;
        this.options = options;
        util.extend(this, util.pick(options, ['url', 'scheme', 'tileSize', 'setColor']));

        this.setEventedParent(eventedParent);

    }

    load() {
        this.fire('dataloading', { dataType: 'source' });

        loadTileJSON(this.options, this.map._transformRequest, (err, tileJSON) => {
            if (err) {
                return this.fire('error', err);
            }
            util.extend(this, tileJSON);
            this.fire('data', { dataType: 'source', sourceDataType: 'metadata' });
            this.fire('data', { dataType: 'source', sourceDataType: 'content' });
        });
    }
    onAdd(map) {
        this.map = map;
        this.load();
    }

    serialize() {
        return {
            type: 'raster',
            url: this.url,
            tileSize: this.tileSize,
            tiles: this.tiles
        };
    }

    loadTile(tile, callback) {
        let url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme), this.url, this.tileSize);
        if (this.lercVersion === 1)
            url = this.setLercUrl(tile);

        // const tileId = tile.tileID.canonical.id;
        const headers = this.headers;
        const requestParameters = {
            url,
            headers,
        };
        tile.request = getArrayBuffer(requestParameters, done.bind(this), this.headers);

        function done(err, response) {
            if (tile.aborted) {
                tile.state = 'unloaded';
                callback(null);
            } else if (err) {
                tile.state = 'errored';
                callback(err);
            } else if (response) {
                let canvas = window.document.createElement('canvas');
                canvas.height = 256;
                canvas.width = 256;
                const imgContext = canvas.getContext('2d');
                const imageData = imgContext.createImageData(256, 256);

                const pixels = imageData.data;
                const lercdata = Lerc.decode(response.data, { returnMask: true });

                const decodedPixelBlock = lercdata.pixels[0];
                tile.lerc = lercdata;
                tile.canvas = canvas;
                for (let i = 0; i < 256 * 256; i++) {
                    const j = i + Math.floor(i / 256);
                    let rgb = [0, 0, 0, 0];
                    if (this.lercVersion === 1)
                        rgb = lercUtil.getColor(this.paint, decodedPixelBlock[j]);
                    else
                        rgb = lercUtil.getColor(this.paint, decodedPixelBlock[i]);

                    pixels[i * 4] = rgb[0];
                    pixels[i * 4 + 1] = rgb[1];
                    pixels[i * 4 + 2] = rgb[2];
                    pixels[i * 4 + 3] = rgb[3];
                }
                imgContext.putImageData(imageData, 0, 0);

                if (this.mask) {
                    imgContext.globalCompositeOperation = 'destination-in';
                    const img = new window.Image();
                    img.crossOrigin = "anonymous";
                    img.src = this.maskUrl.replace('{x}', tile.tileID.canonical.x).replace('{y}', tile.tileID.canonical.y).replace('{z}', tile.tileID.canonical.z);
                    // let _this = this;

                    img.onload = () => {
                        imgContext.drawImage(img, 0, 0);
                        delete tile.request;

                        if (tile.aborted) {
                            this.state = 'unloaded';
                            return callback(null);
                        }

                        if (err) {
                            this.state = 'errored';
                            return callback(err);
                        }
                        const context = this.map.painter.context;
                        const gl = context.gl;

                        tile.canvas = canvas;
                        tile.texture = this.map.painter.getTileTexture(canvas.width);
                        if (tile.texture) {
                            tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
                            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
                        } else {
                            tile.texture = new Texture(context, canvas, gl.RGBA);
                            tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);

                            if (this.map.painter.extTextureFilterAnisotropic) {
                                gl.texParameterf(gl.TEXTURE_2D, this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.map.painter.extTextureFilterAnisotropicMax);
                            }
                        }
                        gl.generateMipmap(gl.TEXTURE_2D);
                        // console.timeEnd('allrender')
                        tile.state = 'loaded';
                        canvas = null;
                        callback(null);
                    };
                } else {
                    delete tile.request;

                    if (tile.aborted) {
                        this.state = 'unloaded';
                        return callback(null);
                    }

                    if (err) {
                        this.state = 'errored';
                        return callback(err);
                    }
                    const context = this.map.painter.context;
                    const gl = context.gl;

                    tile.canvas = canvas;
                    tile.texture = this.map.painter.getTileTexture(canvas.width);
                    if (tile.texture) {
                        tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
                        gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
                    } else {
                        tile.texture = new Texture(context, canvas, gl.RGBA);
                        tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);

                        if (this.map.painter.extTextureFilterAnisotropic) {
                            gl.texParameterf(gl.TEXTURE_2D, this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.map.painter.extTextureFilterAnisotropicMax);
                        }
                    }
                    gl.generateMipmap(gl.TEXTURE_2D);
                    // console.timeEnd('allrender')
                    tile.state = 'loaded';
                    canvas = null;
                    callback(null);
                }
            }

        }
    }
    updateLayer(min, max) {
        this.min = min;
        this.max = max;
        this._eventedParent.reload();
    }
    updateLayerColor(colors) {
        this.colors = colors;
        this._eventedParent.reload();
    }
    setLercUrl(tile) {
        let z = tile.tileID.canonical.z,
            y = tile.tileID.canonical.y.toString(16),
            x = tile.tileID.canonical.x.toString(16);
        if (z < 10) z = `0${z}`;
        const rLength = y.length; // row è¡å·

        if (rLength < 8) {
            for (let i = 0; i < 8 - rLength; i++) {
                y = `0${y}`;
            }
        }
        const r = `R${y}`;
        const cLength = x.length;
        if (cLength < 8) {
            for (let i = 0; i < 8 - cLength; i++) {
                x = `0${x}`;
            }
        }
        const c = `C${x}`; // æ ¹
        const url = `http://101.201.77.235:8080/L${
            z}/${r}/${c}.lerc`;
        return url;
    }
    setLercColor(ele) {
        if (ele < this.min || ele > this.max) {
            return [0, 0, 0, 255];
        }

        let colorIndex = parseInt(ele / 800);
        if (colorIndex < 0) colorIndex = 0;
        if (colorIndex > 10) colorIndex = 10;
        function convertHex(hex) {
            if (hex === undefined) {
                return [0, 0, 0, 0];
            }
            hex = hex.replace('#', '');
            const r = parseInt(hex.substring(0, 2), 16),
                g = parseInt(hex.substring(2, 4), 16),
                b = parseInt(hex.substring(4, 6), 16);

            return [r, g, b, 256];
        }

        return convertHex(this.colors[colorIndex]);
    }
    lercColor(ele) {
        let colorIndex = parseInt(ele / this.step);
        if (colorIndex < 0) colorIndex = 0;
        if (colorIndex > 10) colorIndex = 10;
        function convertHex(hex) {
            if (hex === undefined) {
                return [0, 0, 0, 0];
            }
            hex = hex.replace('#', '');
            const r = parseInt(hex.substring(0, 2), 16),
                g = parseInt(hex.substring(2, 4), 16),
                b = parseInt(hex.substring(4, 6), 16);

            return [r, g, b, 255];
        }

        // return this.colors[colorIndex]

        // if (ele < this.min || ele > this.max) {
        //     return [0, 0, 0, 0]
        // }

        // let colorIndex = parseInt(ele / (this.max - this.min) * 10)
        // if (colorIndex < 0) colorIndex = 0
        // if (colorIndex > 10) colorIndex = 10
        // function convertHex(hex) {
        //     if (!hex) {
        //         return [0, 0, 0, 0]
        //     }
        //     hex = hex.replace('#', '')
        //     var r = parseInt(hex.substring(0, 2), 16),
        //         g = parseInt(hex.substring(2, 4), 16),
        //         b = parseInt(hex.substring(4, 6), 16)

        //     return [r, g, b, 256]
        // }

        return convertHex(this.colors[colorIndex]);
    }
    abortTile(tile) {
        if (tile.request) {
            tile.request.abort();
            delete tile.request;
        }
    }

    unloadTile(tile) {
        if (tile.texture) this.map.painter.saveTileTexture(tile.texture);
    }

    update(options) {
        // console.dir(this);
        util.extend(this, util.pick(options, ['headers', 'lercVersion', 'mask', 'maskUrl', 'tileSize']));
        if (options.paint)
            this.paint = lercUtil.handlePaint(options.paint);
        this._eventedParent.reload();
    }
    hasTransition() {
        return false;
    }
}

export default LercTileSource;
